import { apiClient } from "./apiClient";

export interface CommunicationChannelRequest {
  channelType?: "WHATSAPP" | null;
  legalEntityId: string;
  branchId?: string | null;
  whatsappPhone?: string | null;
  whatsappEnabled?: boolean | null;
  sourceCrm?: string | null;
  whatsappPhoneNumberId?: string | null;
  whatsappAccessToken?: string | null;
  whatsappBusinessAccountId?: string | null;
  active?: boolean | null;
}

export interface EmailChannelRequest {
  channelType: "EMAIL";
  channelId?: string | null;
  legalEntityId: string;
  branchId?: string | null;
  sourceCrm?: string | null;
  emailEnabled?: boolean | null;
  emailId: string;
  inboxLabel?: string | null;
}

export const communicationChannelsService = {
  upsert: (body: CommunicationChannelRequest) =>
    apiClient.post("/communication-channels", body).then((r) => r.data),
  upsertEmail: (body: EmailChannelRequest) =>
    apiClient.post("/communication-channels", body).then((r) => r.data),
  syncTemplates: (id: string, type: 'LE' | 'BR', accessToken: string) =>
    apiClient.post(`/whatsapp/templates/sync/${id}?type=${type}&accessToken=${accessToken}`).then((r) => r.data),
  onboardWhatsapp: (code: string | null, legalEntityId: string, branchId?: string | null, provider?: string | null) =>
    apiClient.post("/communication-channels/whatsapp/onboard", { code, legalEntityId, branchId, provider }).then((r) => r.data),
};
